import { ItemLoader, UpdateContainer, useEntity, useModel } from 'components';
import { useHasPerm } from 'core/permissions';
import { PricesForm } from 'modules/supplier/pricelist/PricesForm';
import { PriceList } from 'modules/supplier/pricelist/types';
import { ReactElement } from 'react';

export function Prices({ vendorId }: { vendorId: number }): ReactElement {
  const { permissions } = useModel();
  const {
    endpoint,
    item: { type },
  } = useEntity<PriceList>();
  const hasUpdate = useHasPerm(permissions?.change);

  const url = `${endpoint}prices/`;

  return (
    <ItemLoader<any> url={url}>
      {({ item, mutate }) => (
        <UpdateContainer
          url={url}
          initialValues={item}
          updateItem={async (value) => {
            await mutate(value, { revalidate: false });
          }}
          method="POST"
          disabled={!hasUpdate}
        >
          <PricesForm vendorId={vendorId} type={type} />
        </UpdateContainer>
      )}
    </ItemLoader>
  );
}
